import React from 'react';
import { Modal } from 'react-bootstrap';

import SendMessageToPerformer from './SendMessageToPerformer';


import "./styles/PerformerOffline.css"


const F2FSendMessageToPerformer = ({ sessionData, isOpen, toggle, messageText = null, hideUsername = false }) => {


    return (
        <>
            <Modal
                className={`f2f-performer-offline-modal ${localStorage.getItem("isDark") === "true" ? "dark" : "light"}`}
                size="md"
                centered
                show={isOpen}
                onHide={toggle}
                scrollable={true}
            >

                <Modal.Body>
                    <SendMessageToPerformer
                        data={sessionData}
                        onSuccess={toggle}
                        messageText={messageText}
                        hideUsername={hideUsername}
                    />
                </Modal.Body>
            </Modal>
        </>
    )
}

export default F2FSendMessageToPerformer;
